var modal_controller = {
    class: 'modal',
    active_class: 'active',
    hash_parse: function () {
        var hash = window.location.hash;
        if (hash.length == 0) {
            return;
        } else {
            var $target = $(hash);
            if (
                $target.length
                && $target.hasClass(modal_controller.class)
            ) {
                jQuery('.'+modal_controller.class).removeClass(modal_controller.active_class);
                $target.addClass(modal_controller.active_class);
                jQuery('.modal-container').addClass('active');
            }

            var second_target = 'dialog#modal-' + hash.split('#')[1];
            if ($(second_target).length && !$(second_target).hasClass('active')) {
                $(second_target).addClass('active');
                $(second_target)[0].showModal();
                $(second_target).find('.syn-modal-close').click(function () {
                    $(second_target).removeClass('active');
                    $(second_target)[0].close();
                });
            }
        }
    },
    init: function () {
        this.hash_parse();
        $('a[href*="#"]:not([href="#"])').click(function () {
            var target = $(this.hash);

            if (!target.hasClass('modal')) {
                    $('html, body').animate({
                        scrollTop: (target.offset().top - 100)
                    }, 1000);
                    return false;
            } else {
                if (!target.hasClass('active')) {
                    target.addClass('active');
                }
            }

            var second_target = 'dialog#modal-' + this.hash.split('#')[1];
            if ($(second_target).length && !$(second_target).hasClass('active')) {
                $(second_target)[0].showModal();
                $(second_target).addClass('active');
                $(second_target).find('.syn-modal-close').click(function () {
                    $(second_target).removeClass('active');
                    $(second_target)[0].close();
                });
            }
        });
        $('.modal .close-modal').click(function () {
            $(this).closest('.modal').removeClass('active');
            jQuery('.modal-container').removeClass('active');
            history.pushState({}, '', window.location.pathname);
        });

        //Detect if the backdrop was clicked while a modal was active and dismiss
        $('body').on('click', function (e) {
            $target = $(e.target);
            if (!$target.closest('.modal.active').length || $target.is('.modal.active')) {
                $target.removeClass('active');
                jQuery('.modal-container').removeClass('active');
                history.pushState({}, '', window.location.pathname);
            }
        });

        $('body').on('exit-intent', function () {
            if (window.syn && window.syn.cf7_form_config) {
                for(var i in window.syn.cf7_form_config){
                    var config = window.syn.cf7_form_config[i];
                    var target = $(config.target);
                    if (target.length && !target.hasClass('active')) {
                        if (target.is('dialog')) {
                            target[0].showModal();
                            target.find('.syn-modal-close').click(function () {
                                target.removeClass('active');
                                target[0].close();
                            });
                        }
                        target.addClass('active');
                    }
                }
            }
        });
    },
};

var mobile_menu = {
    init: function () {
        $('.navbar-toggler').click(function () {

            var $target = $('#' + $(this).attr('aria-controls'));

            if ($target.attr('aria-expanded') == 'true') {
                $('.navbar-toggler').find('i').removeClass('icon-plus').removeClass('rotate-45').addClass('icon-bars');
            }else{
                $('.navbar-toggler').find('i').removeClass('icon-bars').addClass('icon-plus').addClass('rotate-45');
            }

            $target.slideToggle(150, function () {
                if ($target.attr('aria-expanded') == 'true') {
                    $target.attr('aria-expanded', 'false'); 
                } else {
                    $target.attr('aria-expanded', 'true');
                }
            });
        });

        $(document).on('click', '.mobile-menu-contain li:not([aria-expanded="true"]) .mobile_expander', function (e) {
            e.preventDefault();
            $('.mobile-menu-contain li[aria-expanded="true"]').attr('aria-expanded', 'false').find('.sub-menu').slideUp(200);
            let $parent = $(this).parent();
            $(this).siblings('.sub-menu').slideDown(100, function () {
                if ($parent.attr('aria-expanded') == 'true') {
                    $parent.attr('aria-expanded', 'false');
                } else {
                    $parent.attr('aria-expanded', 'true');
                }
            });
        });

        $(document).on('click', '.mobile-menu-contain li[aria-expanded="true"] .mobile_expander', function (e) {
            e.preventDefault();
            $(this).parent().attr('aria-expanded', 'false');
            $(this).siblings('.sub-menu').slideUp(100);
        });
    }
};

jQuery(document).ready(function ($) {
    modal_controller.init();
    mobile_menu.init();
});

class exit_intent_controller{
    breakpoint = 768;  
    desktop_scroll_threshold = 200;
    mobile_scroll_threshold = 400;
    previous_scroll_position = 0;
    idle_time_threshold = 30000; // 30 seconds
    idle_timeout = null;
    locked = false;
    scroll_to_zero_timeout = null;
    scroll_speed = 0;
    disable_event = false;
    constructor(){
        window.addEventListener('mousemove', this.mouse_move_event.bind(this));
        window.addEventListener('scroll', this.scroll_event.bind(this));
        window.addEventListener('load', this.reset_idle_timer.bind(this));
        window.addEventListener('click', this.reset_idle_timer.bind(this));
        window.addEventListener('keydown', this.reset_idle_timer.bind(this));
        window.addEventListener('touchstart', this.reset_idle_timer.bind(this));

        //Check for change in window visibility
        document.addEventListener('visibilitychange', () => {
            if(document.visibilityState === 'hidden'){
                this.blur_event();
            }
        });
    }



    blur_event(){
        if(this.locked || this.disable_event){
            return;
        }
        //Emit exit-intent event on the body
        jQuery('body').trigger('exit-intent');
        campaign_cf7_controller.emitTagEvent('exit-intent');
        //Clear our idle timeout to prevent multiple triggers
        if(this.idle_timeout){
            clearTimeout(this.idle_timeout);
        }
        this.locked = true;
    }

    reset_idle_timer(){
        if(this.idle_timeout){
            clearTimeout(this.idle_timeout);
        }
        this.idle_timeout = setTimeout(() => {
            this.blur_event();
        }, this.idle_time_threshold);
    }

    mouse_move_event(){
        this.reset_idle_timer();
    }
    subtract_scroll_speed(){
        let current_scroll_speed = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--scroll-speed')) || 0;
        let neg = current_scroll_speed < 0 ? -1 : 1;
        let subtract_amount = this.scroll_speed * 0.05;
        //make sure the subtract_amount is getting closer to zero than the current scroll speed, otherwise reverse it to ensure it goes towards zero
        if(Math.abs(current_scroll_speed - subtract_amount) > Math.abs(current_scroll_speed)){
            subtract_amount = subtract_amount * -1;
        }
        if(Math.abs(subtract_amount) < 0.001){
            subtract_amount = 0.001 * neg;
        }

        

        let new_scroll_speed = current_scroll_speed - subtract_amount;
        if(neg === -1 && new_scroll_speed > 0){
            new_scroll_speed = 0;
        }else if(neg === 1 && new_scroll_speed < 0){
            new_scroll_speed = 0;
        }
        //console.log('Current Scroll Speed:', current_scroll_speed, 'New Scroll Speed:', new_scroll_speed);
        document.documentElement.style.setProperty('--scroll-speed', new_scroll_speed);
        if(Math.abs(new_scroll_speed) > 0){
            //Add request animation frame to continue subtracting scroll speed until it reaches 0
            requestAnimationFrame(this.subtract_scroll_speed.bind(this));
        }
    }
    scroll_event(){
        let scroll_position = window.scrollY || window.pageYOffset;

        if(scroll_position < this.previous_scroll_position){
            let scroll_distance = this.previous_scroll_position - scroll_position;

            if(window.innerWidth >= this.breakpoint){
                if(scroll_distance > this.desktop_scroll_threshold){
                    //Emit exit-intent event on the body
                    this.blur_event();
                }
            }else{
                if(scroll_distance > this.mobile_scroll_threshold){
                    //Emit exit-intent event on the body
                    this.blur_event();
                }
            }
        }
        //If we've reached the bottom of the page, blur
        if((window.innerHeight + window.scrollY) >= document.body.offsetHeight){
            //this.blur_event();
            setTimeout(this.blur_event.bind(this), 1000);
        }
       /* var current_scroll_speed = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--scroll-speed')) || 0;
        var scroll_speed = (scroll_position - this.previous_scroll_position) / (window.innerHeight || 1);

        //Get absolute value of both speeds
        var abs_current_scroll_speed = Math.abs(current_scroll_speed);
        var abs_scroll_speed = Math.abs(scroll_speed);

        if(abs_scroll_speed > abs_current_scroll_speed){
            document.documentElement.style.setProperty('--scroll-speed', scroll_speed);
            this.scroll_speed = scroll_speed;
        }
        var that = this;

        requestAnimationFrame(function(){
            that.subtract_scroll_speed();
        });*/

        this.previous_scroll_position = scroll_position;
        this.reset_idle_timer();
    }
}

jQuery(document).ready(function($){
    window.exit_intent = new exit_intent_controller();
});